
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M80.75 46.153c3.333 1.925 3.333 6.736 0 8.66L24.5 87.29c-3.333 1.924-7.5-.482-7.5-4.33V18.007c0-3.85 4.167-6.255 7.5-4.33l56.25 32.475z","fill":"#e5b409"}})])
          )
        }
      }
    